// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u8Gz","controls":"styles_controls__20KjY","charLimit":"styles_charLimit__aWSFg","input":"styles_input__9bL_Y","send":"styles_send__3_1yu"};